import { storeFilterSelector } from "tsi-common-react/src/apps/retail/selectors";
import { preferredLocationSelector } from "tsi-common-react/src/store/common/selectors";
import {
    registerCascade,
    registerLocationTriggeredCascade,
} from "tsi-common-react/src/utils/cascade";

import { store } from "../../store";
import {
    getFlagshipStoreByExternalID,
    nearestFlagshipStoreSelector,
    selectedProductSelector,
} from "./selectors";
import { loadClosestStoresTempurpedic, loadFlagshipStorePage } from "./thunks";

// Trigger store load when location becomes available (either from detection or rehydration)
registerLocationTriggeredCascade(async () => {
    const state = store.getState();
    const location = preferredLocationSelector(state);
    const filters = storeFilterSelector(state);
    const selectedProduct = selectedProductSelector(state);

    if (location && filters) {
        const key = `${JSON.stringify(location)}${selectedProduct}${JSON.stringify(filters)}`;

        await store.dispatch(
            loadClosestStoresTempurpedic({
                location,
                filters,
                selectedProduct,
                loadKey: key,
            }),
        );
    }
});

// Load Stores when location changes
registerCascade(store, {
    debounce: 500,

    transformState: (state) => {
        return state;
    },

    getKey: (state) => {
        // prefer entered location zip over detected location zip
        const location = preferredLocationSelector(state);
        const selectedProduct = selectedProductSelector(state);
        // Trigger new request if filter changes
        const storeFilters = storeFilterSelector(state);

        return `${JSON.stringify(location)}${selectedProduct}${JSON.stringify(
            storeFilters,
        )}`;
    },

    doCascade: async (key, state) => {
        if (key === state.retail.storesLoadedKey) {
            return true;
        }

        const location = preferredLocationSelector(state);
        const selectedProduct = selectedProductSelector(state);
        const storeFilters = storeFilterSelector(state);

        if (!location || !storeFilters) {
            return false;
        }

        // Use the loadClosestStoresTempurpedic thunk to fetch and update stores
        // The thunk handles fetching from multiple sources, deduplication, sorting,
        // and state updates (including product availability) in its fulfilled case
        await store.dispatch(
            loadClosestStoresTempurpedic({
                location,
                filters: storeFilters,
                selectedProduct,
                loadKey: key,
            }),
        );
        return true;
    },
});

// When nearest flagship store changes, load the corresponding CMS Page
registerCascade(store, {
    debounce: 500,

    transformState: (state) => {
        return state;
    },

    getKey: (state) => {
        const nearestFlagshipStore = nearestFlagshipStoreSelector(state);
        return `${nearestFlagshipStore ? nearestFlagshipStore.external_id : 0}`;
    },

    doCascade: async (_, state) => {
        const nearestFlagshipStore = nearestFlagshipStoreSelector(state);
        if (!nearestFlagshipStore) {
            return true;
        }
        // No need to load the page if it's already in Redux state
        if (
            getFlagshipStoreByExternalID(
                state.retail.flagshipStorePages,
                nearestFlagshipStore.external_id,
            )
        ) {
            return true;
        }
        try {
            await store.dispatch(
                loadFlagshipStorePage(nearestFlagshipStore.external_id),
            );
            // eslint-disable-next-line unused-imports/no-unused-vars
        } catch (e) {
            // Ignore page 404s here
        }
        return true;
    },
});
